import axios from 'axios';
import { API_BASE_URL } from '../constants';
import store from "../store";

const api = (headers = {}) => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    // headers
    headers: { 'x-kickavenue-platform': 'web', ...headers }
  })

  instance.interceptors.response.use(
    response => {
      // Do something with response 
      return response;
    },
    (error) => {
      if (error.response && (error.response.status === 302 && (error.response.data && error.response.data.error && error.response.data.error.status_code === 503)))
        store.dispatch({
          type: "ERROR_MAINTENANCE_MODE"
        })

      if (error.response && (error.response.status === 426 && (error.response.data && error.response.data.error && error.response.data.error.status_code === 426)))
        store.dispatch({
          type: "ERROR_NEW_BUILD_HANDLER"
        })

      // Do something with response error
      return Promise.reject(error);
    }
  )

  return instance;
}

export const noReduxApi = (headers = {}) => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: { 'x-kickavenue-platform': 'web', ...headers }
  })

  instance.interceptors.response.use(
    response => {
      // Do something with response 
      return response;
    },
    (error) => {
      // Do something with response error
      return Promise.reject(error);
    }
  )

  return instance;
}

export default api;